import { Component, ChangeDetectionStrategy } from '@angular/core';
import { UIComponentsModule } from 'src/app/shared/ui-components/ui-components.module';
import { AuthService } from 'src/app/core/auth/auth.service';

@Component({
  selector: 'app-landing-page',
  imports: [UIComponentsModule],
  templateUrl: './landing-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './landing-page.component.scss',
})
export class LandingPageComponent {
  constructor(public authService: AuthService) {}
}
